import { render, staticRenderFns } from "./AboutSupplier.vue?vue&type=template&id=405401db&scoped=true"
import script from "./AboutSupplier.vue?vue&type=script&lang=js"
export * from "./AboutSupplier.vue?vue&type=script&lang=js"
import style0 from "./AboutSupplier.vue?vue&type=style&index=0&id=405401db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405401db",
  null
  
)

export default component.exports